import React, { useEffect, useMemo, useRef, useState } from "react";
import { CommonSelect, DatePicker, Input } from "common/InputForm";
import { CustomButton } from "components/form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoCloudUploadOutline } from "react-icons/io5";
import { GoX } from "react-icons/go";
import { blogDetailApi, editBlogApi, getProductListApi } from "services/blog";
import Select from "react-select";
import useButtonLoader from "common/UseButtonLoader";
import JoditEditor from "jodit-react";
import CommonForm from "./CommonForm";
import { MultiSelect } from "react-multi-select-component";

const EditBlog = () => {
  const editor = useRef(null);
  const [productList, setProductList] = useState([])
  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monaco,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );
  const navigate = useNavigate();
  const { id } = useParams();
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Save and Submit");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    bodyShape: [],
    bodyShapeValue: [],
    styleIdentity: [],
    styleIdentityValue: [],
    flauntParts: [],
    flauntPartsValue: [],
    downplayParts: [],
    downplayPartsValue: [],
    tag: "",
    category: "",
    images: [],
    thumb: null,
    mediaToRemoveIds: [],
    isTrending: false, // Added isTrending key
    productIds: [],
    productLabelValue: []
  });
  const [selectedOptions, setSelectedOptions] = useState({
    paletteName: [],
    bodyShape: [],
    styleIdentity: [],
    flauntParts: [],
    downplayParts: [],
  })
  console.log('selectedOptions', selectedOptions)
  console.log('errors', errors)
  console.log('formData', formData)
  const [paletteName, setPaletteName] = useState([]);
  const paletteOptions = [
    { value: "Dark Winter", label: "Dark Winter" },
    { value: "Bright Winter", label: "Bright Winter" },
    { value: "True Winter", label: "True Winter" },
    { value: "Bright Spring", label: "Bright Spring" },
    { value: "Light Spring", label: "Light Spring" },
    { value: "True Spring", label: "True Spring" },
    { value: "Dark Autumn", label: "Dark Autumn" },
    { value: "Soft Autumn", label: "Soft Autumn" },
    { value: "True Autumn", label: "True Autumn" },
    { value: "Light Summer", label: "Light Summer" },
    { value: "Soft Summer", label: "Soft Summer" },
    { value: "True Summer", label: "True Summer" },
  ];
  const handlePaletteChange = (selectedOptions) => {
    setPaletteName(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, paletteName: null }));
  };
  // console.log(formData, "formData");
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((pre) => ({
      ...pre,
      [name]: null,
    }));
  };

  const handleMediaChange = (e) => {
    const files = Array.from(e.target.files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      type: file.type.startsWith("video/") ? "video" : "image",
    }));
    setFormData((prevData) => ({
      ...prevData,
      images: [...prevData.images, ...files],
    }));
    setErrors((prevData) => ({ ...prevData, media: null }));
  };

  const handleThumbChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        thumb: {
          file,
          preview: URL.createObjectURL(file),
        },
      }));
    }
  };

  const removeMedia = (index) => {
    const removedMedia = formData.images[index];

    // Append the media ID to the mediaToRemove array
    if (removedMedia.id) {
      setFormData((prevData) => ({
        ...prevData,
        mediaToRemoveIds: [
          ...(prevData.mediaToRemoveIds || []),
          removedMedia.id,
        ],
      }));
    }
    // Remove the media from the images array
    const updatedMedia = formData.images.filter((_, i) => i !== index);
    setFormData((prevData) => ({ ...prevData, images: updatedMedia }));
  };

  const removeThumb = () =>
    setFormData((prevData) => ({ ...prevData, thumb: null }));

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.tag) newErrors.tag = "Tag is required";

    // if (formData.bodyShape.length === 0)
    //   newErrors.bodyShape = "At least one bodyShape is required";
    // if (formData.bodyShapeValue.length === 0)
    //   newErrors.bodyShapeValue = "Body shape value is required";
    // if (formData.styleIdentity.length === 0)
    //   newErrors.styleIdentity = "At least one styleIdentity is required";
    // if (formData.styleIdentityValue.length === 0)
    //   newErrors.styleIdentityValue = "StyleIdentity value is required";

    // if (formData.flauntParts.length === 0)
    //   newErrors.flauntParts = "At least one flaunt part is required";
    // if (formData.flauntPartsValue.length === 0)
    //   newErrors.flauntPartsValue = "Flaunt Parts Value is required";
    // if (formData.downplayParts.length === 0)
    //   newErrors.downplayParts = "At least one downplay part is required";
    // if (formData.downplayPartsValue.length === 0)
    //   newErrors.downplayPartsValue = "Downplay Parts Value is required";

    if (!formData.description)
      newErrors.description = "Description is required";
    if (!formData.category)
      newErrors.category = "Please Select  Category  is required";
    // Check if media (images or video) is provided
    if (formData?.images?.length === 0) {
      newErrors.media = "At least one image or video is required";
    }
    // if (paletteName.length === 0)
    //   newErrors.paletteName = "Palette Name is required";

    // Validate if more than one video is uploaded
    const videoFiles = formData?.images?.filter((file) =>
      file?.type?.startsWith("video/")
    );
    if (videoFiles.length > 1) {
      newErrors.media = "Only one video upload is allowed";
    }
    // If there is a video, check for the thumb
    if (
      videoFiles?.length === 1 &&
      (!formData.thumb || formData.thumb === "")
    ) {
      newErrors.thumb = "Thumb is required for video ";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const bodyShapeArray = [
    { value: "Round", label: "Round" },
    { value: "Triangle", label: "Triangle" },
    { value: "Hourglass", label: "Hourglass" },
    { value: "Rectangle", label: "Rectangle" },
    { value: "Inverted Triangle", label: "Inverted Triangle" },
  ];
  const handleBodyShape = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      bodyShape: selectedOptions.map((option) => option.value),
      bodyShapeValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, bodyShapeValue: null }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      setButtonLoaders(true);
      let payLoad = {
        paletteName: selectedOptions.paletteName?.map((item) => item.value),
        flauntParts: selectedOptions.flauntParts?.map((item) => item.value),
        bodyShape: selectedOptions.bodyShape?.map((item) => item.value),
        downplayParts: selectedOptions.downplayParts?.map((item) => item.value),
        styleIdentity: selectedOptions.styleIdentity?.map((item) => item.value),
        // scrapeUrl: debouncedValue,
        // products: selectedProducts,
      };
      const formDatas = new FormData();
      formDatas.append("id", formData.id);
      formDatas.append("mediaToRemove", formData.mediaToRemoveIds);
      formDatas.append("title", formData.title);
      formDatas.append("description", formData.description);
      formDatas.append("tag", formData.tag);
      formDatas.append("isTrending", formData.isTrending);

      // formDatas.append("bodyShape", JSON.stringify(formData.bodyShape));
      // formDatas.append("styleIdentity", JSON.stringify(formData.styleIdentity));
      // formDatas.append("flauntParts", JSON.stringify(formData.flauntParts));
      // formDatas.append("downplayParts", JSON.stringify(formData.downplayParts));
      // formDatas.append("paletteName", JSON.stringify(paletteName));
      formDatas.append("bodyShape", JSON.stringify(payLoad.bodyShape));
      formDatas.append("styleIdentity", JSON.stringify(payLoad.styleIdentity));
      formDatas.append("flauntParts", JSON.stringify(payLoad.flauntParts));
      formDatas.append("downplayParts", JSON.stringify(payLoad.downplayParts));
      formDatas.append("paletteName", JSON.stringify(payLoad.paletteName));

      formDatas.append("productIds", JSON.stringify(formData.productIds));
      formDatas.append("category", formData.category);
      formData.images.forEach((image) => {
        formDatas.append("media", image.file);
      });
      if (formData.thumb) formDatas.append("thumb", formData.thumb.file);
      // If a video exists, append the video (only one video can be uploaded)
      if (formData.video) {
        formDatas.append("media", formData.video.file);
      }
      const res = await editBlogApi(formDatas);
      if (res?.data?.status === 200) {
        toastMessage(res?.data?.message, "success", "addBlog");
        navigate(-1);
        setButtonLoaders(false);
      }
    } catch (e) {
      toastMessage(e.message, "error", "addBlog");
    } finally {
      setButtonLoaders(false);
    }
  };
  const handleflauntParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      flauntParts: selectedOptions.map((option) => option.value),
      flauntPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, flauntPartsValue: null }));
  };

  //---------product-onChange----------------
  const handleProduct = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      productIds: selectedOptions.map((option) => option.value),
      productLabelValue: selectedOptions,
    }))
  };
  const handledownplayParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      downplayParts: selectedOptions.map((option) => option.value),
      downplayPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, downplayPartsValue: null }));
  };
  const downplayArray = [
    { value: "Neckline", label: "Neckline" },
    { value: "Waist", label: "Waist" },
    { value: "Legs", label: "Legs" },
    { value: "Arms", label: "Arms" },
    { value: "Back", label: "Back" },
    { value: "Buttocks", label: "Buttocks" },
  ];
  const styleIdentityArray = [
    { value: "Bold Boss", label: "Bold Boss" },
    { value: "Dreamy Diva", label: "Dreamy Diva" },
    { value: "Timeless Queen", label: "Timeless Queen" },
    { value: "Effortless Chic", label: "Effortless Chic" },
  ];
  const handleStyleIdentity = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      styleIdentity: selectedOptions.map((option) => option.value),
      styleIdentityValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, styleIdentityValue: null }));
  };

  const fetchBlogDetails = async () => {
    try {
      const { data } = await blogDetailApi(id);
      const blog = data?.data?.blog || {};
      // const product = data?.data?.product || {};

      setSelectedOptions({
        ...multiSelectValueHandler(blog),
        // category: blog.category || "",
        // brand: blog.brand?._id || "",
        // colorName: blog.color || {}
      });

      setFormData({
        id: id,
        title: blog.title || "",
        description: blog.description || "",
        tag: blog.tag,
        category: blog.category,
        // styleIdentity: blog.styleIdentity || [],
        // styleIdentityValue: blog?.styleIdentity?.map((value) =>
        //   styleIdentityArray.find((item) => item.value === value)
        // ) || [],
        // bodyShape: blog.bodyShape || [],
        // bodyShapeValue: blog?.bodyShape?.map((value) =>
        //   bodyShapeArray.find((item) => item.value === value)
        // ) || [],
        // flauntParts: blog.flauntParts || [],
        // flauntPartsValue:
        //   blog.flauntParts?.map((value) =>
        //     downplayArray.find((item) => item.value === value)
        //   ) || [],
        //--------product--------------
        productIds: blog.relatedProducts || [],
        // productLabelValue:
        //   blog.relatedProducts?.map((value) =>
        //     productList.find((item) => item.value === value)
        //   ) || [],
        productLabelValue:
          blog.relatedProducts?.map((value) => {
            const product = productList.find((item) => item.value === value);
            return product ? { label: product.label, value: product.value } : null;
          }).filter(Boolean) || [],


        // downplayParts: blog.downplayParts || [],
        // downplayPartsValue:
        //   blog.downplayParts?.map((value) =>
        //     downplayArray.find((item) => item.value === value)
        //   ) || [],


        images: blog.media.map((media) => ({
          id: media._id,
          type: media.type,
          url: media.url,
        })),
        isTrending: blog.isTrending,
        thumb:
          blog.media.find((media) => media.type === "video")?.thumb || null,
      });
      // setPaletteName(blog.paletteName ? blog.paletteName : []);
    } catch (error) {
      toastMessage(error.message, "error", "blogDetails");
    }
  };
  // Handle Checkbox Change
  const handleCheckboxChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      isTrending: e.target.checked,
    }));
  };
  useEffect(() => {
    fetchBlogDetails();
  }, [id, productList]);
  // ------------user-listing-----------------
  useEffect(() => {
    const productList = async () => {
      try {
        const res = await getProductListApi();
        if (res?.data?.status === 200) {
          const user = res?.data?.data?.products
          setProductList(user?.map((product) => ({ label: product.title, value: product._id, })));
        } else {
          toastMessage(res?.data?.message || "Bad request", "error", "productElse");
        }
      } catch (e) {
        toastMessage(e.message, "error", "productCatch");
      }
    };
    productList()
  }, [])

  const multiSelectValueHandler = (projectObject) => {
    const extractValue = [
      "paletteName",
      "bodyShape",
      "styleIdentity",
      "flauntParts",
      "downplayParts",
    ];

    const dummySelectedValue = {};

    extractValue.forEach((key) => {
      // if (key === "occasionName") {
      //   dummySelectedValue["occasionName"] = projectObject["occasion"].map((item) => ({ value: item, label: item }));
      // } else if (key === "availableSizes") {
      //   dummySelectedValue["availableSizes"] = projectObject["sizes"].map((item) => ({ value: item, label: item }));
      // }
      if (Array.isArray(projectObject[key])) {
        dummySelectedValue[key] = projectObject[key].map((item) => ({ value: item, label: item }));
      } else {
        dummySelectedValue[key] = [];
      }
    });
    return dummySelectedValue
  };
  return (
    <div className="editProduct">
      <div className="dashboard_title has_child">
        <h3>
          <Link to={`/blog-management`}>
            <IoMdArrowRoundBack />
          </Link>
          Edit Blog
        </h3>
        <CustomButton onClick={handleSubmit} ref={buttonLoaders}>
          Update
        </CustomButton>
      </div>

      <div className="card">
        <div className="card-body">
          <form>
            <div className="form_field is_trending_wrap">
              <label className="label" htmlFor="isTrending">Is Trending</label>
              <input
                type="checkbox"
                id="isTrending"
                checked={formData.isTrending}
                onChange={handleCheckboxChange}
              />
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <Input
                  type="text"
                  label="Title"
                  name="title"
                  placeholder="Enter Title"
                  value={formData.title}
                  onChange={handleInputChange}
                  error={errors.title}
                />
              </div>
              <div className="form_field">
                <label className="label">Category</label>
                <select
                  className="input form-control"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                >
                  <option>Select Category</option>
                  <option value="blog">Blog</option>
                  <option value="tutorial">Tips & Tutorials</option>
                  <option value="inspiration">Inspiration</option>
                  <option value="lookbook">Lookbook</option>

                </select>
                {errors && (
                  <span className="text-danger">{errors.category}</span>
                )}
              </div>
            </div>
            <div className="form_field">
              <Input
                type="text"
                label="Tag"
                name="tag"
                placeholder="Enter Tag"
                value={formData.tag}
                onChange={handleInputChange}
                error={errors.tag}
              />
            </div>


            {/* <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Style Identity</label>
                <Select
                  placeholder={<div>Select Style Identity</div>}
                  name="select"

                  className="multi_select multi-select"
                  value={formData.styleIdentityValue}
                  options={styleIdentityArray}
                  isMulti
                  onChange={handleStyleIdentity}
                />
                {errors && (
                  <div className="text-danger">{errors.styleIdentityValue}</div>
                )}
              </div>
              <div className="form_field">
                <label className="label">Body Shape</label>

                <Select
                  placeholder={<div>Select Body Shape</div>}
                  name="select"

                  className="multi_select multi-select"
                  value={formData.bodyShapeValue}
                  options={bodyShapeArray}
                  isMulti
                  onChange={handleBodyShape}
                />
                {errors && (
                  <div className="text-danger">{errors.bodyShapeValue}</div>
                )}
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Flaunt Parts</label>
                <Select
                  placeholder={<div>Select Flaunt Parts</div>}
                  name="select"
                  className="multi_select multi-select"
                  value={formData.flauntPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handleflauntParts}
                />
                {errors && (
                  <span className="text-danger">{errors.flauntPartsValue}</span>
                )}
              </div>
              <div className="form_field">
                <label className="label">Downplay Parts</label>
                <Select
                  placeholder={<div>Select Downplay Parts</div>}
                  name="select"
                  className="multi_select multi-select"
                  value={formData.downplayPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handledownplayParts}
                />
                {errors && (
                  <span className="text-danger">
                    {errors.downplayPartsValue}
                  </span>
                )}
              </div>

            </div> */}

            <CommonForm {...{ selectedOptions, setSelectedOptions, errors, setErrors }} />

            {formData?.category === "lookbook" &&
              <div className="form_field_wrap">
                <div className="form_field">
                  <label className="label">Select Product</label>
                  {/* <CommonSelect
                    placeholder={<div>Select product</div>}
                    name="productLabelValue"
                    className="multi-select multi_select"
                    value={formData.productLabelValue}
                    options={productList}
                    isMulti
                    onChange={handleProduct}
                  /> */}
                  <MultiSelect
                    className="w-100"
                    name='productLabelValue'
                    options={productList}
                    value={formData?.productLabelValue}
                    onChange={handleProduct}
                    overrideStrings={{
                      selectSomeItems: "Select product"
                    }}
                  />
                </div>
              </div>
            }


            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Description</label>
                <JoditEditor
                  ref={editor}
                  value={formData.description}
                  // config={config}
                  tabIndex={1}
                  onBlur={(newContent) => {
                    setFormData((prevData) => ({
                      ...prevData,
                      description: newContent,
                    }));
                    setErrors((prevData) => ({
                      ...prevData,
                      description: null,
                    }));
                  }}
                  config={config}
                />
                {errors && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>
              <div className="form_field">
                <label className="label">Upload Media</label>
                <div className="upload_button_wrap">
                  <label
                    htmlFor="upload_images"
                    className="upload_button input"
                  >
                    <IoCloudUploadOutline className="icon" />
                    <input
                      type="file"
                      multiple
                      accept="image/*, video/*"
                      onChange={handleMediaChange}
                      id="upload_images"
                    />
                    <span className="text">Select file to upload</span>
                  </label>
                  {errors.media && (
                    <span style={{ color: "red" }}>{errors.media}</span>
                  )}
                  <div className="image_preview_wrap">
                    {formData.images.map((media, index) => (
                      <div key={index} className="image_preview">
                        {media.type === "image" && (
                          <img
                            src={media.preview || media.url}
                            alt="preview"

                          />
                        )}
                        {media.type === "video" && (
                          <video
                            src={media.preview || media.url}
                            controls
                            style={{
                              width: "150px",
                              height: "auto",
                              marginRight: "10px",
                            }}
                          />
                        )}
                        <button
                          type="button"
                          onClick={() => removeMedia(index)}
                          style={{ marginLeft: "10px" }}
                        >
                          <GoX />
                        </button>
                      </div>

                    ))}
                  </div>
                </div>

                {/* Thumbnail upload */}
                {formData.images.some((file) => file.type === "video") && (
                  <div style={{ marginTop: "10px" }}>
                    <label className="label">Upload Thumbnail for Video:</label>
                    <input type="file" onChange={handleThumbChange} />
                    {errors.thumb && (
                      <span style={{ color: "red" }}>{errors.thumb}</span>
                    )}
                    {formData.thumb && (
                      <div style={{ marginTop: "10px" }}>
                        <img
                          src={formData.thumb.preview || formData.thumb}
                          alt="thumbnail"
                          style={{ width: "100px", height: "auto" }}
                        />
                        <button
                          type="button"
                          onClick={removeThumb}
                          style={{ marginLeft: "10px" }}
                        >
                          <GoX />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditBlog;
